export enum FlagNames {
    Da = "da",
    En = "en",
    Fr = "fr",
    De = "de",
    Uk = "uk",
    Es = "es",
}
